import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css";
import { useTranslation } from "react-i18next";
import i18next from "../i18n";
import { Helmet } from "react-helmet-async";
import LogoCarousel from "../components/LogoCarousel";
import Button from "../components/Button";
import ccm_svg from "../images/illustrations/ccm.svg";
import universal_svg from "../images/illustrations/uu.svg";
import klp_logo from "../images/customers/klp.svg";
import dnb_logo from "../images/customers/dnb.svg";
import gjensidige_logo from "../images/customers/gjensidige.svg";
import circlek_logo from "../images/customers/circle_k.svg";
import nav_logo from "../images/customers/nav.svg";
import nav_logo_dark from "../images/customers/nav_dark.svg";
import { useNavigate } from "react-router-dom";
import uu_icon from "../images/illustrations/UU_icon.svg";
import floatingDocuments from "../images/illustrations/docengine/floating-documents.svg";
import validatedPdf from "../images/illustrations/docengine/validated-pdf.svg";
const history_image = require("../images/IMG_4532.JPG");
const team_outing_image = require("../images/IMG_3854.JPG");

const company_logos = [
  {
    name: "KLP",
    img: klp_logo,
  },
  {
    name: "DNB",
    img: dnb_logo,
  },
  {
    name: "Gjensidige",
    img: gjensidige_logo,
  },
  {
    name: "Circle K",
    img: circlek_logo,
  },
  {
    name: "Nav",
    img: nav_logo,
  },
];

function Main() {
  useTranslation();
  const navigate = useNavigate();
  var settings = {
    dots: true,
    arrows: false,
    autoplay: false,
    infinite: true,
    dotsClass: "slick-dots-fw slick-dots",
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="min-h-screen bg-white ">
      <Helmet>
        <title>{i18next.t("pages.main.title")} -  {i18next.t("pages.main.hero.title")}</title>
        <meta
          name="description"
          content={`${i18next.t("pages.main.hero.description")}`}
        />
        <link rel="canonical" href="https://xperconsulting.no" />
      </Helmet>
      <div className="bg-white ">
        <div className="container max-w-2xl flex flex-col items-start gap-4 pb-8 pt-20 md:flex-row md:items-center md:gap-12 md:pb-12 md:pt-28">
          <div className="w-full min-w-0 max-w-3xl text-left md:flex-1">
            <h1 className="mb-6 text-4xl font-bold leading-[1.1] text-main-dark md:text-6xl">
              {i18next.t("pages.main.hero.title")}
            </h1>
            <p className="mb-0 text-lg leading-relaxed text-secondary md:text-xl">
              {i18next.t("pages.main.hero.description")}{" "}
            </p>
          </div>
          <div className="relative isolate flex min-h-[230px] w-full items-center justify-center md:min-h-[340px] md:w-[38%] md:shrink-0">
            <img src={floatingDocuments} alt="" aria-hidden="true" width="560" height="480" className="pointer-events-none absolute inset-0 -z-10 h-full w-full object-contain" />
            <Button
              variant="solid"
              color="contrast"
              size="large"
              onClick={() => {
                navigate("/skjema/snakk-med-ekspert");
              }}
            >
              {i18next.t("pages.main.hero.cta")}
            </Button>
          </div>
        </div>

        <div className="container max-w-[80rem] flex-col py-12 md:py-16">
         
          <h2 className="bold mb-8 text-left text-lg font-medium leading-relaxed tracking-normal text-secondary md:text-xl">
            {i18next.t("pages.main.services.subtitle")}
          </h2>
          <div className="grid gap-6 text-left md:grid-cols-3 md:gap-6">
            <button
              type="button"
              onClick={() => {
                navigate("/docengine");
              }}
              className="group flex w-full flex-col rounded-2xl bg-[linear-gradient(125deg,#536780_0%,#45556D_58%,#354258_100%)] p-8 text-left shadow-[0_14px_32px_-22px_rgba(46,56,72,0.42)] transition-transform duration-300 motion-safe:hover:-translate-y-1 motion-reduce:transition-none focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-main md:p-8"
            >
              <h3 className="mb-0 text-3xl font-bold leading-tight md:text-4xl">
                {i18next.t("pages.main.services.docengine.title")}
              </h3>
              <p className="mb-0 text-sm font-medium leading-relaxed text-white md:text-base">
                {i18next.t("pages.main.services.docengine.subtitle")}
              </p>
              <p className="mt-6 mb-0 text-base leading-relaxed md:text-lg">
                {i18next.t("pages.main.services.docengine.description")}
              </p>
              <span className="mt-auto flex items-center justify-end gap-2 pt-2 text-base font-bold">
                {i18next.t("pages.main.services.docengine.linkText")}
                <span
                  aria-hidden="true"
                  className="transition-transform duration-300 group-hover:translate-x-1"
                >
                  →
                </span>
              </span>
            </button>
            <button
              type="button"
              onClick={() => {
                  navigate("/ccm");
                }}
              className="group flex w-full flex-col rounded-2xl bg-[linear-gradient(to_bottom_left,#B18E76_0%,#A27A5F_55%,#89644D_100%)] p-8 text-left shadow-[0_14px_32px_-22px_rgba(46,56,72,0.42)] transition-transform duration-300 motion-safe:hover:-translate-y-1 motion-reduce:transition-none focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-main md:p-8"
            >
               
              <h3 className="mb-0 text-3xl font-bold leading-tight  md:text-4xl">
                {i18next.t("pages.main.services.ccm.title")}
              </h3>
              <p className="mb-0 text-sm font-medium leading-relaxed text-white md:text-base">
                {i18next.t("pages.main.services.ccm.subtitle")}
              </p>
              <p className="mt-6 mb-0 text-base leading-relaxed md:text-lg">
                {i18next.t("pages.main.services.ccm.description")}
              </p>
              <span className="mt-6 flex items-center justify-end gap-2 pt-2 text-base font-bold opacity-90">
                {i18next.t("pages.main.services.ccm.linkText")}
                <span
                  aria-hidden="true"
                  className="transition-transform duration-300 group-hover:translate-x-1"
                >
                  →
                </span>
              </span>
            </button>
            <button
              type="button"
              onClick={() => {
                navigate("/migrator");
              }}
              className="group flex w-full flex-col rounded-2xl bg-[linear-gradient(135deg,#43556E_0%,#304157_52%,#223247_100%)] p-8 text-left shadow-[0_14px_32px_-22px_rgba(46,56,72,0.42)] transition-transform duration-300 motion-safe:hover:-translate-y-1 motion-reduce:transition-none focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-main md:p-8"
            >
              <h3 className="mb-0 text-3xl font-bold leading-tight md:text-4xl">
                {i18next.t("pages.main.services.migrator.title")}
              </h3>
              <p className="mb-0 text-sm font-medium leading-relaxed text-white md:text-base">
                {i18next.t("pages.main.services.migrator.subtitle")}
              </p>
              <p className="mb-0 mt-6 text-base leading-relaxed md:text-lg">
                {i18next.t("pages.main.services.migrator.description")}
              </p>
              <span className="mt-6 flex items-center justify-end gap-2 pt-2 text-base font-bold opacity-90">
                {i18next.t("pages.main.services.migrator.linkText")}
                <span aria-hidden="true" className="transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </span>
            </button>
          </div>
        </div>

        <div className="container relative z-10 -mb-48 flex-col max-w-xl md:-mb-52 mt-20">
          <div className="flex flex-col overflow-hidden rounded-2xl bg-main shadow-[0_14px_32px_-22px_rgba(46,56,72,0.42)] md:flex-row">
            
            <div className="w-full break-words px-8 py-12 text-left md:w-3/5 md:px-24 md:py-20">
              <h2 className="mb-3 text-xl font-semibold leading-snug text-white md:text-2xl">
                {i18next.t("pages.main.docengine.subtitle")}
              </h2>
              <h3 className="mb-5 text-4xl font-bold leading-tight text-white md:text-5xl">
                {i18next.t("pages.main.docengine.title")}
              </h3>
              <p className="mb-0 text-base leading-relaxed text-white/90 md:text-lg">
                {i18next.t("pages.main.docengine.description")}
              </p>
              <div className="mt-8 flex flex-row">
                <Button
                  variant="solid"
                  color="white"
                  size="large"
                  onClick={() => {
                    navigate("/skjema/book-demo");
                  }}
                >
                  {i18next.t("pages.main.docengine.cta")}
                </Button>
              </div>
            </div>

            <div className="flex w-full flex-col items-center justify-center px-8 pb-10 md:w-2/5 md:px-24 md:py-12">
              <img
                alt={i18next.t("pages.main.docengine.illustrationAlt")}
                src={uu_icon}
                className="w-2/3 max-w-[12rem]"
              />
              <div className="mt-6 flex w-full justify-end">
                <a
                  href="/docengine"
                  className="text-sm font-semibold text-white underline underline-offset-4 transition-colors hover:text-white-dark"
                >
                  {i18next.t("pages.main.docengine.readMore")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative bg-gray pt-56 md:pt-52">

        <div className="container relative z-10 max-w-md pb-16 -mt-12">
          <section aria-labelledby="pdf-check-title" className="grid w-full items-center gap-6 rounded-2xl bg-white px-7 py-10 text-left shadow-[0_14px_32px_-22px_rgba(46,56,72,0.42)] md:grid-cols-2 md:gap-10 md:px-12 md:py-14">
            <img src={validatedPdf} alt="" aria-hidden="true" width="560" height="380" loading="lazy" className="mx-auto h-auto w-full max-w-[28rem]" />
            <div>
            <h2 id="pdf-check-title" className="mb-4 text-3xl font-bold leading-tight text-main-dark md:text-4xl">
              {i18next.t("pages.main.pdf-check.title")}
            </h2>
            <p className="mb-7 max-w-sm text-base leading-relaxed text-secondary md:text-lg">
              {i18next.t("pages.main.pdf-check.description")}
            </p>
            <button
              type="button"
              className="rounded-md bg-main px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-main-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-main"
              onClick={() => {
                navigate("/skjema/test-dokument-tilgjengelighet");
              }}
            >
              {i18next.t("pages.main.pdf-check.button")}
            </button>
            </div>
          </section>
        </div>
    
      </div>
      <div className="bg-main px-4 py-20 md:py-24">
        <div className="container flex flex-col p-0">
          <h2 className="mr-auto px-4 text-left text-2xl font-bold leading-tight text-white md:px-0 md:text-3xl">
            {i18next.t("pages.main.customers.title")}
          </h2>
          <LogoCarousel logos={company_logos} className="mt-10" />
        </div>
      </div>

      <div className="bg-gray py-20 md:py-28">
        <div className="container max-w-xl text-left text-main-dark">
          <div className="grid w-full grid-cols-1 gap-y-10 md:grid-cols-12 md:gap-y-0">
            <img
              src={team_outing_image}
              alt=""
              loading="lazy"
              className="aspect-[4/3] w-full rounded-2xl object-cover md:col-span-7 md:col-start-1 md:row-start-1"
            />
            {[
              {
                key: "gjensidige2", company: "Gjensidige", logo: gjensidige_logo,
                placement: "md:col-span-6 md:col-start-7 md:row-start-1 md:self-start md:mt-8",
              },
              {
                key: "nav", company: "NAV", logo: nav_logo_dark,
                placement: "md:col-span-6 md:col-start-4 md:row-start-2 md:-my-36 md:self-center md:-translate-y-8",
              },
              {
                key: "gjensidige1", company: "Gjensidige", logo: gjensidige_logo,
                placement: "md:col-span-6 md:col-start-1 md:row-start-3 md:self-end md:-translate-y-8",
              },
            ].map(({ key, company, logo, placement }) => (
              <div key={key} className={`relative z-10 m-0 flex h-64 flex-col justify-center rounded-2xl p-8 md:p-10 lg:p-12 ${key === "nav" ? "bg-secondary-light text-white" : "bg-white text-main-dark"} ${placement}`}>
                <div className="m-0 text-xl leading-relaxed lg:text-2xl">
                  <p className="mb-0">{i18next.t(`pages.main.testimonials.${key}`)}</p>
                </div>
                <div className="mt-6 flex justify-end">
                  <img
                    className={`h-10 w-auto brightness-0 ${key === "nav" ? "invert" : "opacity-75"}`}
                    alt={i18next.t("pages.main.customers.logoAlt", { company })}
                    src={logo}
                  />
                </div>
              </div>
            ))}
            <img
              src={history_image}
              alt=""
              loading="lazy"
              className="row-start-4 aspect-[4/3] w-full rounded-2xl object-cover md:col-span-7 md:col-start-6 md:row-start-3 md:-mt-8"
            />
          </div>
        </div>

        <div className="container mt-20 flex max-w-2xl flex-wrap items-center justify-center gap-6 text-main-dark md:mt-24 md:flex-nowrap">
          <p className="mb-0 text-center text-lg font-medium leading-relaxed md:text-left md:text-xl">{i18next.t("pages.main.cta.question")}</p>
          <Button
            variant="solid"
            color="mainDark"
            onClick={() => {
              navigate("/skjema/kontakt-oss");
            }}
          >
            {i18next.t("pages.main.cta.button")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Main;
